import WarrantyPanelComponent from "./warrantyPanel.container";

export default WarrantyPanelComponent;
